export function crmFieldSelectAndLabel() {
  return {
    restrict: 'E',
    template: require('./crm-field-select-and-label.directive.html'),
    scope: {
      companyId: '<',
      organizationId: '<',
      entry: '=',
      objectsDescriptions: '=',
      contactObjectName: '<'
    },
    controller: controller
  };
}

controller.$inject = ['$scope', 'CrmFactory'];
function controller($scope, CrmFactory) {

  $scope.onFieldNameUpdated = onFieldNameUpdated;
  $scope.onReferenceFieldNameUpdated = onReferenceFieldNameUpdated;

  if ($scope.entry.child_object_name) {
    $scope.objectName = $scope.entry.child_object_name;
  } else {
    $scope.objectName = $scope.contactObjectName;
  }

  function onFieldNameUpdated() {
    // Find field by its name
    let field = $scope.objectsDescriptions[$scope.objectName].fields.find(field => field.name == $scope.entry.field_name);
    $scope.entry.field_type = field.type;

    if (field.type === 'reference') {
      CrmFactory.loadObjectDescription($scope.companyId, $scope.organizationId, field.referenceTo[0], $scope.objectsDescriptions);

      $scope.entry.display_label = '';
      $scope.entry.reference_to = field.referenceTo[0];
      $scope.entry.reference_relationship_name = field.relationshipName;
      $scope.entry.reference_field_name = '';
      $scope.entry.reference_field_type = '';
    } else {
      $scope.entry.display_label = field.label;
    }
  }

  function onReferenceFieldNameUpdated() {
    // Find field by its name
    let field = $scope.objectsDescriptions[$scope.entry.reference_to].fields.find(field => field.name == $scope.entry.reference_field_name);
    $scope.entry.reference_field_type = field.type;
    $scope.entry.display_label = field.label;
  }
}
